module.exports = __webpack_public_path__ + "img/创建团队.cec3fb1b.svg";